export default __webpack_public_path__ + "static/media/992.d757b2b5.png";